export const saveToStorage = (
	key: string,
	value: any,
	useSession = false,
	days = 0,
) => {
	const storage = useSession ? sessionStorage : localStorage;
	try {
		const expires = days > 0 ? Date.now() + days * 86400000 : null;
		const data = { value, expires };
		storage.setItem(key, JSON.stringify(data));
	} catch (error) {
		console.error(
			`Error saving to ${useSession ? "sessionStorage" : "localStorage"}:`,
			error,
		);
	}
};

export const getFromStorage = <T>(
	key: string,
	useSession = false,
): T | null => {
	const storage = useSession ? sessionStorage : localStorage;
	try {
		const item = storage.getItem(key);
		if (!item) return null;

		const { value, expires } = JSON.parse(item);

		if (expires && Date.now() > expires) {
			storage.removeItem(key);
			return null; // Expired data
		}

		return value as T;
	} catch (error) {
		console.error(
			`Error getting from ${useSession ? "sessionStorage" : "localStorage"}:`,
			error,
		);
		return null;
	}
};

export const removeFromStorage = (key: string, useSession = false) => {
	const storage = useSession ? sessionStorage : localStorage;
	try {
		storage.removeItem(key);
	} catch (error) {
		console.error(
			`Error removing from ${useSession ? "sessionStorage" : "localStorage"}:`,
			error,
		);
	}
};
